import React, { useState } from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';

import Arrow from "../../../assets/images/Services/right-arrow.png";
import { FaCheckCircle } from "react-icons/fa";


import img1 from "../../../assets/images/Product/Attendance/img1.jpg"; // left image
import img2 from "../../../assets/images/Product/Attendance/img2.jpg"; // right image
import img3 from "../../../assets/images/Product/Attendance/img3.jpg"; // right image
import img4 from "../../../assets/images/Product/Attendance/img4.jpg"; // right image
import img5 from "../../../assets/images/Product/Attendance/img5.jpg"; // right image
import img6 from "../../../assets/images/Product/Attendance/img6.jpg"; // right image

import './attendance.css';

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import SEO from '../../seo';


export default function Attendance() {
    const [openImageIndex, setOpenImageIndex] = useState(null);

    const images = [img1, img2, img3, img4, img5, img6];
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];

    return (
        <div>
            <SEO
                title="Attendance System"
                description="At HWPL! we recognize that privacy is important. This Privacy Policy applies to all products and services provided by us. Collection Of Information Disclaimer: Please read and edit the Privacy Policy given below as per your /website’s requirement. Don’t use or apply these as is basis on your website. We collect various information when you [&hellip;]"
                canonical="https://www.hwplindia.com/products/attendance-system/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Attendance System</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>
                            <Link to="/products">Products</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Attendance System</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section1">

                <div className="at-container">

                    {/* Content Section */}
                    <div className="branding-content">
                        {/* CTA */}
                        <section className="cta-section attendance-h3">
                            <h3 className=''>“Attendance System with Face Recognition & Payroll Automation”</h3>
                            <p>
                                At Horizon Webinfo Pvt. Ltd. we believe technology should simplify operations and enhance productivity. Our AI-powered Attendance & Payroll Automation System is designed to streamline HR processes, ensure accuracy, and bring complete transparency to workforce management.
                            </p>
                            <h3 className='cta-section-business-process it-consult attendance-consult'>Why an Intelligent Attendance System?</h3>
                        </section>


                        {/* Sections */}
                        <section className='it-consult simple-section'>
                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Face Recognition: The Future of Secure Attendance</h4>
                                <p>
                                    Our system uses advanced AI-based facial recognition with anti-spoofing and mask detection, ensuring foolproof identity verification. No proxies, no manual errors — just seamless, automated attendance tracking with maximum security.                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Smart Payroll Automation for Error-Free Processing</h4>
                                <p>
                                    The solution automates salary calculations, including overtime, late marks, early exit, PF, ESIC, and TDS, ensuring precise payouts every month. Reduce repetitive HR tasks and eliminate calculation errors.                                </p>
                            </section>

                            {/* Our Expertise in Attendance */}
                            <section className="cta-section">
                                <h3 className='cta-section-business-process attendance-expert'>Our Expertise in Attendance & Payroll Technology</h3>
                            </section>
                            <section className='simple-section attaaa'>

                                <section className="attendance-li">
                                    <h4>
                                        AI-Powered Attendance</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Highly accurate facial recognition</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Anti-spoofing & mask detection</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Real-time sync across mobile & web</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Comprehensive HR Management</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Shift, leave & holiday planning</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> GPS-based attendance for field staff</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Automated payroll integrated with attendance</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Insightful Analytics</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Detailed reporting dashboard</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Productivity insights</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Exportable data for audits & compliance</li></p>
                                </section>
                            </section>

                            <div className='image-swip'>
                                <Swiper
                                    modules={[Navigation, Pagination, Autoplay]}
                                    slidesPerView={4}          // show 2 images at a time
                                    spaceBetween={0}
                                    slidesPerGroup={1}         // slide one by one
                                    navigation={false}
                                    pagination={{ clickable: true, dynamicBullets: false }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    loop={true}
                                    breakpoints={{
                                        // Mobile
                                        0: {
                                            slidesPerView: 1,
                                        },

                                        // Small devices (landscape phones)
                                        576: {
                                            slidesPerView: 2,
                                        },

                                        // Tablets
                                        1015: {
                                            slidesPerView: 3,
                                        },

                                        // Desktop
                                        1330: {
                                            slidesPerView: 4,
                                        },
                                    }}
                                    className="branding-swiper attendance-swiper"
                                >

                                    <SwiperSlide onClick={() => setOpenImageIndex(0)}>
                                        <img src={img1} className="attendance-img att1" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(1)}>
                                        <img src={img2} className="attendance-img att1" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(2)}>
                                        <img src={img3} className="attendance-img att1" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(3)}>
                                        <img src={img4} className="attendance-img att1" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(4)}>
                                        <img src={img5} className="attendance-img att1" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(5)}>
                                        <img src={img6} className="attendance-img att1" />
                                    </SwiperSlide>

                                </Swiper>
                                {openImageIndex !== null && (
                                    <div className="image-popup">

                                        <div className="close-btn" onClick={() => setOpenImageIndex(null)}>
                                            ✕
                                        </div>

                                        <div className="popup-img-wrapper">

                                            <button
                                                className="popup-swiper-arrow left"
                                                onClick={() =>
                                                    setOpenImageIndex(
                                                        (openImageIndex - 1 + images.length) % images.length
                                                    )
                                                }
                                            >
                                                ❮
                                            </button>

                                            <img
                                                src={images[openImageIndex]}
                                                alt="preview"
                                                className="popup-big-img"
                                            />

                                            <button
                                                className="popup-swiper-arrow right"
                                                onClick={() =>
                                                    setOpenImageIndex((openImageIndex + 1) % images.length)
                                                }
                                            >
                                                ❯
                                            </button>

                                        </div>

                                    </div>
                                )}

                            </div>


                            {/* Why This Helps Your Business */}

                            <section className="cta-section simple-section1">
                                <h3 className='cta-section-business-process attendance-expert why-lead '>Why This Helps Your Business</h3>
                            </section>

                            <section className="simple-section">
                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4> Reduces Manual HR Work by Up to 70%</h4>
                                        <p>Automation eliminates repetitive tasks, allowing HR teams to focus on strategic work instead of data entry.</p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Eliminates Proxy & Buddy Punching</h4>
                                        <p>AI face recognition ensures only the actual employee can mark attendance — saving cost and increasing discipline.</p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Accurate & Transparent Payroll</h4>
                                        <p>Salaries are calculated based on real data, reducing disputes and ensuring complete transparency for employees.</p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Better Compliance & Audit-Ready Data</h4>
                                        <p>All attendance, leave, and payroll records are stored digitally, making compliance simple and reducing legal risks.</p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Improves Workforce Efficiency</h4>
                                        <p>Employees manage their own shifts, leaves, and payslips via the app — improving clarity and reducing HR queries.</p>
                                    </div>
                                </div>
                            </section>

                            {/* Why Choose Us */}
                            <section className="why-choose attendance-choose">
                                <h3>Who Is This Ideal For?</h3>
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Manufacturing Units</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Offices & Corporate Teams</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Contractors & Field Workforce</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Contractors & Field Workforce</li>
                                </ul>
                            </section>

                            {/* CTA */}
                            <section className="cta-section attendance-p">
                                <h3>Collaborate with Us</h3>
                                <p>
                                    At Horizon Webinfo Pvt. Ltd. we combine AI innovation with practical workforce solutions to transform your HR operations. Whether you’re growing your team or managing a large workforce, our Smart Attendance & Payroll System is designed to scale with you.

                                </p>
                                <Link to="/get-a-quote" className="quote-btn1-brand">
                                    <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> GET A QUOTE</span>
                                </Link>
                            </section>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}